import { Reveal } from "./Reveal";

export const Chapter = ({ no, eyebrow, title, intro, dark = false, id }) => (
    <div id={id} className="scroll-mt-24">
        <Reveal>
            <p
                className={`font-mono text-xs sm:text-sm tracking-[0.3em] uppercase ${
                    dark ? "text-[#A8BC9B]" : "text-fern"
                }`}
                data-testid={`chapter-${no}-eyebrow`}
            >
                Chapter {no} — {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] max-w-3xl ${
                    dark ? "text-cream" : "text-[#1c1917]"
                }`}
                data-testid={`chapter-${no}-title`}
            >
                {title}
            </h2>
        </Reveal>
        {intro && (
            <Reveal delay={0.16}>
                <p
                    className={`mt-6 max-w-2xl text-base sm:text-lg leading-relaxed ${
                        dark ? "text-stone-300" : "text-stone-600"
                    }`}
                >
                    {intro}
                </p>
            </Reveal>
        )}
    </div>
);
